import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchBanners as fetchBannersApi,
  fetchDeals as fetchDealsApi,
  fetchOffers as fetchOffersApi,
  fetchReviews as fetchReviewsApi,
  subscribeNewsletter as subscribeNewsletterApi,
} from "@/services/api/common";

const initialState = {
  offers: [],
  deals: [],
  reviews: [],
  banners: [],
  newsletterLoading: false,
  loading: false,
  error: null,
};

export const fetchOffers = createAsyncThunk(
  "common/fetchOffers",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchOffersApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load offers");
    }
  }
);

export const fetchDeals = createAsyncThunk(
  "common/fetchDeals",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchDealsApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load deals");
    }
  }
);

export const fetchReviews = createAsyncThunk(
  "common/fetchReviews",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchReviewsApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load reviews");
    }
  }
);

export const fetchBanners = createAsyncThunk(
  "common/fetchBanners",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchBannersApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load banners");
    }
  }
);

export const submitNewsletter = createAsyncThunk(
  "common/submitNewsletter",
  async (payload, { rejectWithValue }) => {
    try {
      return await subscribeNewsletterApi(payload);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to subscribe newsletter");
    }
  }
);

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    clearCommonError(state) {
      state.error = null;
    },
    resetCommonState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOffers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOffers.fulfilled, (state, action) => {
        state.loading = false;
        state.offers = action.payload;
      })
      .addCase(fetchOffers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDeals.fulfilled, (state, action) => {
        state.deals = action.payload;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.reviews = action.payload;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.banners = action.payload;
      })
      .addCase(submitNewsletter.pending, (state) => {
        state.newsletterLoading = true;
      })
      .addCase(submitNewsletter.fulfilled, (state) => {
        state.newsletterLoading = false;
      })
      .addCase(submitNewsletter.rejected, (state, action) => {
        state.newsletterLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCommonError, resetCommonState } = commonSlice.actions;
export default commonSlice.reducer;
